// "use client";

// import {
//     motion,
//     useScroll,
//     useSpring,
//     useTransform,
// } from "framer-motion";

// import {
//     useEffect,
//     useRef,
//     useState,
// } from "react";

// import "../assets/css/ProcessSection.css";


// const processSteps = [
//     {
//         title: "Inquiry & Quotation",
//         text: "Share your brass part drawing, sample, size, material grade, or custom requirement. Our team reviews the details and provides a clear quotation.",
//     },
//     {
//         title: "Order Confirmation",
//         text: "After approval, we confirm material, quantity, tolerance, finishing, delivery timeline, and packaging requirements.",
//     },
//     {
//         title: "Quality Inspection",
//         text: "Every batch is checked for dimensions, threading, surface finish, material quality, and consistency before dispatch.",
//     },
//     {
//         title: "Finishing & Packaging",
//         text: "Components are cleaned, finished, packed safely, and prepared for local or export delivery as per customer needs.",
//     },
//     {
//         title: "Dispatch & Support",
//         text: "Orders are shipped on time with proper coordination, documentation, and after-sales support for repeat requirements.",
//     },
// ];


// /* =========================================================
//    PROCESS CARD
// ========================================================= */

// // function ProcessCard({ step, index }) {
// //     return (
// //         <motion.div
// //             className="process-card"

// //             initial={{
// //                 opacity: 0,
// //                 y: 35,
// //             }}

// //             whileInView={{
// //                 opacity: 1,
// //                 y: 0,
// //             }}

// //             viewport={{
// //                 once: true,
// //                 margin: "-100px",
// //             }}

// //             transition={{
// //                 duration: 0.65,
// //                 delay: index * 0.08,
// //                 ease: [0.22, 1, 0.36, 1],
// //             }}
// //         >

// //             <div className="process-point">
// //                 <span />
// //             </div>


// //             <div className="process-content">

// //                 <span className="process-number">
// //                     Step {String(index + 1).padStart(2, "0")}
// //                 </span>

// //                 <h3>
// //                     {step.title}
// //                 </h3>

// //                 <p>
// //                     {step.text}
// //                 </p>

// //             </div>

// //         </motion.div>
// //     );
// // }
// function ProcessCard({ step, index, progress }) {

//     const stepPosition = index / 4;

//     const textOpacity = useTransform(
//         progress,
//         [
//             Math.max(stepPosition - 0.08, 0),
//             stepPosition,
//             Math.min(stepPosition + 0.08, 1),
//         ],
//         [
//             0,
//             1,
//             1,
//         ]
//     );

//     const textY = useTransform(
//         progress,
//         [
//             Math.max(stepPosition - 0.08, 0),
//             stepPosition,
//         ],
//         [
//             35,
//             0,
//         ]
//     );

//     return (
//         <div
//             className={`process-card ${index % 2 === 0
//                 ? "process-card-top"
//                 : "process-card-bottom"
//                 }`}
//         >

//             {/* DOT — NO ANIMATION */}
//             <div className="process-point">
//                 <span />
//             </div>


//             {/* ONLY TEXT FADES UP */}
//             <motion.div
//                 className="process-content"
//                 style={{
//                     opacity: textOpacity,
//                     y: textY,
//                 }}
//             >

//                 <span className="process-number">
//                     Step {String(index + 1).padStart(2, "0")}
//                 </span>

//                 <h3>
//                     {step.title}
//                 </h3>

//                 <p>
//                     {step.text}
//                 </p>

//             </motion.div>

//         </div>
//     );
// }

// /* =========================================================
//    BRASS COMPONENT
// ========================================================= */

// // function BrassNut({ progress, timelineWidth }) {

// //     /*
// //      * Keep the nut centered on the actual
// //      * timeline rather than its own wrapper.
// //      */

// //     const nutX = useTransform(
// //         progress,
// //         [0, 1],
// //         [
// //             0,
// //             Math.max(timelineWidth - 90, 0),
// //         ]
// //     );

// //     return (
// //         <motion.div
// //             className="brass-nut-wrapper"
// //             style={{
// //                 x: nutX,
// //             }}
// //         >

// //             <motion.div
// //                 className="brass-nut"

// //                 animate={{
// //                     rotate: [0, 8, -6, 0],
// //                 }}

// //                 transition={{
// //                     duration: 5,
// //                     repeat: Infinity,
// //                     ease: "easeInOut",
// //                 }}
// //             >

// //                 <div className="brass-nut-glow" />

// //                 <div className="brass-nut-shadow" />

// //                 <div className="brass-nut-body" />

// //                 <div className="brass-nut-depth" />

// //                 <div className="brass-nut-hole-shadow" />

// //                 <div className="brass-nut-hole" />

// //                 <div className="brass-nut-highlight" />

// //                 <div className="brass-nut-shine" />

// //             </motion.div>

// //         </motion.div>
// //     );
// // }
// function BrassNut({ progress, timelineWidth }) {

//     /*
//      * The timeline has 5 equally spaced steps.
//      *
//      * Step 01 = 10%
//      * Step 02 = 30%
//      * Step 03 = 50%
//      * Step 04 = 70%
//      * Step 05 = 90%
//      *
//      * Brass component moves exactly
//      * from Step 01 to Step 05.
//      */

//     const firstPoint =
//         timelineWidth * 0;

//     const lastPoint =
//         timelineWidth * 0.88;


//     const nutX = useTransform(
//         progress,
//         [0, 1],
//         [
//             firstPoint - 45,
//             lastPoint - 45,
//         ]
//     );


//     return (
//         <motion.div
//             className="brass-nut-wrapper"

//             style={{
//                 x: nutX,
//             }}
//         >

//             <motion.div
//                 className="brass-nut"

//                 animate={{
//                     rotate: [0, 8, -6, 0],
//                 }}

//                 transition={{
//                     duration: 5,
//                     repeat: Infinity,
//                     ease: "easeInOut",
//                 }}
//             >

//                 <div className="brass-nut-glow" />

//                 <div className="brass-nut-shadow" />

//                 <div className="brass-nut-body" />

//                 <div className="brass-nut-depth" />

//                 <div className="brass-nut-hole-shadow" />

//                 <div className="brass-nut-hole" />

//                 <div className="brass-nut-highlight" />

//                 <div className="brass-nut-shine" />

//             </motion.div>

//         </motion.div>
//     );
// }


// /* =========================================================
//    MAIN SECTION
// ========================================================= */

// export default function ProcessSection() {

//     const timelineRef = useRef(null);

//     const [timelineWidth, setTimelineWidth] =
//         useState(0);



//     /* -----------------------------------------
//        Get actual timeline width
//     ------------------------------------------ */

//     useEffect(() => {

//         const updateWidth = () => {

//             if (!timelineRef.current) {
//                 return;
//             }

//             setTimelineWidth(
//                 timelineRef.current.offsetWidth
//             );

//         };


//         updateWidth();


//         const observer =
//             new ResizeObserver(updateWidth);


//         if (timelineRef.current) {
//             observer.observe(
//                 timelineRef.current
//             );
//         }


//         window.addEventListener(
//             "resize",
//             updateWidth
//         );


//         return () => {

//             observer.disconnect();

//             window.removeEventListener(
//                 "resize",
//                 updateWidth
//             );

//         };

//     }, []);


//     /* -----------------------------------------
//        Scroll progress
//     ------------------------------------------ */

//     const {
//         scrollYProgress,
//     } = useScroll({

//         target: timelineRef,

//         offset: [
//             "start 65%",
//             "end 45%",
//         ],

//     });


//     /* -----------------------------------------
//        Smooth progress
//     ------------------------------------------ */

//     const smoothProgress = useSpring(
//         scrollYProgress,
//         {
//             stiffness: 70,
//             damping: 30,
//             mass: 0.5,
//         }
//     );


//     return (

//         <section className="process-section">

//             <div className="process-container">


//                 {/* ====================================
//             HEADER
//         ===================================== */}

//                 <motion.div
//                     className="process-heading"

//                     initial={{
//                         opacity: 0,
//                         y: 35,
//                     }}

//                     whileInView={{
//                         opacity: 1,
//                         y: 0,
//                     }}

//                     viewport={{
//                         once: true,
//                     }}

//                     transition={{
//                         duration: 0.7,
//                         ease: "easeOut",
//                     }}
//                 >

//                     <span className="process-eyebrow">
//                         Our Process
//                     </span>


//                     <h2>
//                         Unveiling The Process Of
//                         <br />
//                         Precision Brass Parts Production
//                     </h2>

//                 </motion.div>


//                 {/* ====================================
//             TIMELINE
//         ===================================== */}

//                 <div
//                     ref={timelineRef}
//                     className="process-timeline"
//                 >


//                     {/* Background line */}

//                     <div className="process-line" />


//                     {/* Active scroll line */}

//                     <motion.div
//                         className="process-line-active"

//                         style={{
//                             scaleX: smoothProgress,
//                         }}
//                     />


//                     {/* Moving component */}

//                     <BrassNut
//                         progress={smoothProgress}
//                         timelineWidth={timelineWidth}
//                     />


//                     {/* Cards */}

//                     <div className="process-grid">

//                         {/* {processSteps.map(
//                             (step, index) => (

//                                 <ProcessCard
//                                     key={step.title}
//                                     step={step}
//                                     index={index}
//                                 />

//                             )
//                         )} */}
//                         {processSteps.map(
//                             (step, index) => (
//                                 <ProcessCard
//                                     key={step.title}
//                                     step={step}
//                                     index={index}
//                                     progress={smoothProgress}
//                                 />
//                             )
//                         )}

//                     </div>


//                 </div>

//             </div>

//         </section>
//     );
// }





// "use client";

// import {
//     motion,
//     useScroll,
//     useSpring,
//     useTransform,
// } from "framer-motion";

// import {
//     useEffect,
//     useRef,
//     useState,
// } from "react";

// import "../assets/css/ProcessSection.css";


// const processSteps = [
//     {
//         title: "Inquiry & Quotation",
//         text: "Share your brass part drawing, sample, size, material grade, or custom requirement. Our team reviews the details and provides a clear quotation.",
//     },
//     {
//         title: "Order Confirmation",
//         text: "After approval, we confirm material, quantity, tolerance, finishing, delivery timeline, and packaging requirements.",
//     },
//     {
//         title: "Quality Inspection",
//         text: "Every batch is checked for dimensions, threading, surface finish, material quality, and consistency before dispatch.",
//     },
//     {
//         title: "Finishing & Packaging",
//         text: "Components are cleaned, finished, packed safely, and prepared for local or export delivery as per customer needs.",
//     },
//     {
//         title: "Dispatch & Support",
//         text: "Orders are shipped on time with proper coordination, documentation, and after-sales support for repeat requirements.",
//     },
// ];


// /* =========================================================
//    BRASS NUT
// ========================================================= */

// function BrassNut() {
//     return (
//         <motion.div
//             className="brass-nut"

//             animate={{
//                 rotate: [0, 8, -6, 0],
//             }}

//             transition={{
//                 duration: 5,
//                 repeat: Infinity,
//                 ease: "easeInOut",
//             }}
//         >

//             <div className="brass-nut-glow" />

//             <div className="brass-nut-shadow" />

//             <div className="brass-nut-body" />

//             <div className="brass-nut-depth" />

//             <div className="brass-nut-hole-shadow" />

//             <div className="brass-nut-hole" />

//             <div className="brass-nut-highlight" />

//             <div className="brass-nut-shine" />

//         </motion.div>
//     );
// }


// /* =========================================================
//    DESKTOP PROCESS CARD
// ========================================================= */

// function DesktopProcessCard({
//     step,
//     index,
//     progress,
// }) {

//     const stepPosition = index / 4;


//     const textOpacity = useTransform(
//         progress,
//         [
//             Math.max(
//                 stepPosition - 0.08,
//                 0
//             ),
//             stepPosition,
//             Math.min(
//                 stepPosition + 0.08,
//                 1
//             ),
//         ],
//         [
//             0,
//             1,
//             1,
//         ]
//     );


//     const textY = useTransform(
//         progress,
//         [
//             Math.max(
//                 stepPosition - 0.08,
//                 0
//             ),
//             stepPosition,
//         ],
//         [
//             35,
//             0,
//         ]
//     );


//     return (

//         <div
//             className={`process-card ${index % 2 === 0
//                 ? "process-card-top"
//                 : "process-card-bottom"
//                 }`}
//         >

//             {/* DOT */}
//             <div className="process-point">
//                 <span />
//             </div>


//             {/* TEXT ONLY ANIMATES */}
//             <motion.div
//                 className="process-content"

//                 style={{
//                     opacity: textOpacity,
//                     y: textY,
//                 }}
//             >

//                 <span className="process-number">
//                     Step{" "}
//                     {String(index + 1).padStart(
//                         2,
//                         "0"
//                     )}
//                 </span>


//                 <h3>
//                     {step.title}
//                 </h3>


//                 <p>
//                     {step.text}
//                 </p>

//             </motion.div>

//         </div>
//     );
// }


// /* =========================================================
//    MOBILE / TABLET PROCESS CARD
// ========================================================= */

// function MobileProcessCard({
//     step,
//     index,
//     progress,
// }) {

//     const stepPosition = index / 4;


//     /*
//      * Fade-up animation.
//      *
//      * Only the text moves.
//      * Dot stays fixed.
//      */

//     const textOpacity = useTransform(
//         progress,
//         [
//             Math.max(
//                 stepPosition - 0.10,
//                 0
//             ),
//             stepPosition,
//             Math.min(
//                 stepPosition + 0.10,
//                 1
//             ),
//         ],
//         [
//             0,
//             1,
//             1,
//         ]
//     );


//     const textY = useTransform(
//         progress,
//         [
//             Math.max(
//                 stepPosition - 0.10,
//                 0
//             ),
//             stepPosition,
//         ],
//         [
//             35,
//             0,
//         ]
//     );


//     return (

//         <div className="mobile-process-card">

//             {/* DOT */}
//             <div className="mobile-process-point">
//                 <span />
//             </div>


//             {/* TEXT */}
//             <motion.div
//                 className="mobile-process-content"

//                 style={{
//                     opacity: textOpacity,
//                     y: textY,
//                 }}
//             >

//                 <span className="process-number">
//                     Step{" "}
//                     {String(index + 1).padStart(
//                         2,
//                         "0"
//                     )}
//                 </span>


//                 <h3>
//                     {step.title}
//                 </h3>


//                 <p>
//                     {step.text}
//                 </p>

//             </motion.div>

//         </div>
//     );
// }


// /* =========================================================
//    MAIN COMPONENT
// ========================================================= */

// export default function ProcessSection() {

//     const timelineRef = useRef(null);

//     const [timelineWidth, setTimelineWidth] =
//         useState(0);


//     /* =====================================================
//        GET TIMELINE WIDTH
//     ===================================================== */

//     useEffect(() => {

//         const updateWidth = () => {

//             if (!timelineRef.current) {
//                 return;
//             }

//             setTimelineWidth(
//                 timelineRef.current.offsetWidth
//             );

//         };


//         updateWidth();


//         const observer =
//             new ResizeObserver(
//                 updateWidth
//             );


//         if (timelineRef.current) {

//             observer.observe(
//                 timelineRef.current
//             );

//         }


//         window.addEventListener(
//             "resize",
//             updateWidth
//         );


//         return () => {

//             observer.disconnect();

//             window.removeEventListener(
//                 "resize",
//                 updateWidth
//             );

//         };

//     }, []);


//     /* =====================================================
//        SCROLL PROGRESS
//     ===================================================== */

//     const {
//         scrollYProgress,
//     } = useScroll({

//         target: timelineRef,

//         offset: [
//             "start 65%",
//             "end 45%",
//         ],

//     });


//     const smoothProgress = useSpring(
//         scrollYProgress,
//         {
//             stiffness: 70,
//             damping: 30,
//             mass: 0.5,
//         }
//     );


//     /* =====================================================
//        DESKTOP BRASS POSITION
//     ===================================================== */

//     const firstPoint =
//         timelineWidth * 0.10;

//     const lastPoint =
//         timelineWidth * 0.90;


//     const desktopNutX = useTransform(
//         smoothProgress,
//         [0, 1],
//         [
//             firstPoint - 45,
//             lastPoint - 45,
//         ]
//     );


//     /* =====================================================
//        MOBILE BRASS POSITION
//     ===================================================== */

//     /*
//      * The vertical movement is controlled
//      * by CSS variable height.
//      *
//      * 0px → first point
//      * 100% → last point
//      */

//     const mobileNutY = useTransform(
//         smoothProgress,
//         [0, 1],
//         [
//             0,
//             1,
//         ]
//     );
//     // const mobileNutTop = useTransform(
//     //     smoothProgress,
//     //     [0, 1],
//     //     ["0%", "100%"]
//     // );
//     const mobileNutTop = useTransform(
//         smoothProgress,
//         [0, 1],
//         [
//             "0px",
//             "calc(100% - 20px)"
//         ]
//     );

//     return (

//         <section className="process-section">

//             <div className="process-container">


//                 {/* =================================================
//                     HEADING
//                 ================================================= */}

//                 <motion.div
//                     className="process-heading"

//                     initial={{
//                         opacity: 0,
//                         y: 35,
//                     }}

//                     whileInView={{
//                         opacity: 1,
//                         y: 0,
//                     }}

//                     viewport={{
//                         once: true,
//                     }}

//                     transition={{
//                         duration: 0.7,
//                         ease: "easeOut",
//                     }}
//                 >

//                     <span className="process-eyebrow">
//                         / Our Process
//                     </span>


//                     <h2>
//                         Unveiling The Process Of
//                         <br />
//                         Precision Brass Parts Production
//                     </h2>

//                 </motion.div>


//                 {/* =================================================
//                     DESKTOP VERSION
//                 ================================================= */}

//                 <div
//                     ref={timelineRef}
//                     className="process-timeline desktop-process"
//                 >

//                     <div className="process-line" />


//                     <motion.div
//                         className="process-line-active"

//                         style={{
//                             scaleX:
//                                 smoothProgress,
//                         }}
//                     />


//                     <motion.div
//                         className="brass-nut-wrapper"

//                         style={{
//                             x: desktopNutX,
//                         }}
//                     >

//                         <BrassNut />

//                     </motion.div>


//                     <div className="process-grid">

//                         {processSteps.map(
//                             (step, index) => (

//                                 <DesktopProcessCard
//                                     key={step.title}
//                                     step={step}
//                                     index={index}
//                                     progress={
//                                         smoothProgress
//                                     }
//                                 />

//                             )
//                         )}

//                     </div>

//                 </div>


//                 {/* =================================================
//                     MOBILE / TABLET VERSION
//                 ================================================= */}

//                 <div className="mobile-process">

//                     <div className="mobile-process-line" />


//                     <motion.div
//                         className="mobile-process-line-active"

//                         style={{
//                             scaleY:
//                                 mobileNutY,
//                         }}
//                     />


//                     {/* MOVING BRASS */}

//                     <motion.div
//                         className="mobile-brass-wrapper"

//                         // style={{
//                         //     top:
//                         //         useTransform(
//                         //             smoothProgress,
//                         //             [0, 1],
//                         //             [
//                         //                 "0%",
//                         //                 "100%",
//                         //             ]
//                         //         ),
//                         // }}
//                         style={{
//                             top: mobileNutTop,
//                         }}
//                     >

//                         <BrassNut />

//                     </motion.div>


//                     {/* STEPS */}

//                     <div className="mobile-process-grid">

//                         {processSteps.map(
//                             (step, index) => (

//                                 <MobileProcessCard
//                                     key={step.title}
//                                     step={step}
//                                     index={index}
//                                     progress={
//                                         smoothProgress
//                                     }
//                                 />

//                             )
//                         )}

//                     </div>

//                 </div>

//             </div>

//         </section>
//     );
// }





"use client";

import {
    motion,
    useScroll,
    useSpring,
    useTransform,
} from "framer-motion";

import {
    useEffect,
    useRef,
    useState,
} from "react";

import "../assets/css/ProcessSection.css";


/* =========================================================
   PROCESS DATA
========================================================= */

const processSteps = [
    {
        title: "Inquiry & Quotation",
        text: "Share your brass part drawing, sample, size, material grade, or custom requirement. Our team reviews the details and provides a clear quotation.",
    },

    {
        title: "Order Confirmation",
        text: "After approval, we confirm material, quantity, tolerance, finishing, delivery timeline, and packaging requirements.",
    },

    {
        title: "Quality Inspection",
        text: "Every batch is checked for dimensions, threading, surface finish, material quality, and consistency before dispatch.",
    },

    {
        title: "Finishing & Packaging",
        text: "Components are cleaned, finished, packed safely, and prepared for local or export delivery as per customer needs.",
    },

    {
        title: "Dispatch & Support",
        text: "Orders are shipped on time with proper coordination, documentation, and after-sales support for repeat requirements.",
    },
];


/* =========================================================
   BRASS NUT
   Used by both desktop and mobile
========================================================= */

function BrassNut() {

    return (

        <motion.div
            className="brass-nut"

            animate={{
                rotate: [0, 8, -6, 0],
            }}

            transition={{
                duration: 5,
                repeat: Infinity,
                ease: "easeInOut",
            }}
        >

            <div className="brass-nut-glow" />

            <div className="brass-nut-shadow" />

            <div className="brass-nut-body" />

            <div className="brass-nut-depth" />

            <div className="brass-nut-hole-shadow" />

            <div className="brass-nut-hole" />

            <div className="brass-nut-highlight" />

            <div className="brass-nut-shine" />

        </motion.div>
    );
}


/* =========================================================
   DESKTOP PROCESS CARD
========================================================= */

function DesktopProcessCard({
    step,
    index,
    progress,
}) {

    /*
     * Five positions:
     *
     * Step 01 = 0
     * Step 02 = 0.25
     * Step 03 = 0.50
     * Step 04 = 0.75
     * Step 05 = 1
     */

    const stepPosition = index / 4;


    /* -------------------------------
       Fade up
    -------------------------------- */

    const textOpacity = useTransform(
        progress,

        [
            Math.max(
                stepPosition - 0.08,
                0
            ),

            stepPosition,

            Math.min(
                stepPosition + 0.08,
                1
            ),
        ],

        [
            0,
            1,
            1,
        ]
    );


    const textY = useTransform(
        progress,

        [
            Math.max(
                stepPosition - 0.08,
                0
            ),

            stepPosition,
        ],

        [
            35,
            0,
        ]
    );


    return (

        <div
            className={
                `process-card ${index % 2 === 0
                    ? "process-card-top"
                    : "process-card-bottom"
                }`
            }
        >

            {/* DOT */}

            <div className="process-point">

                <span />

            </div>


            {/* ONLY TEXT ANIMATES */}

            <motion.div
                className="process-content"

                style={{
                    opacity: textOpacity,
                    y: textY,
                }}
            >

                <span className="process-number">

                    Step{" "}

                    {String(
                        index + 1
                    ).padStart(
                        2,
                        "0"
                    )}

                </span>


                <h3>
                    {step.title}
                </h3>


                <p>
                    {step.text}
                </p>

            </motion.div>

        </div>
    );
}


/* =========================================================
   MOBILE / TABLET PROCESS CARD
========================================================= */

function MobileProcessCard({
    step,
    index,
    progress,
}) {

    const stepPosition = index / 4;


    /* -------------------------------
       Fade-up animation
    -------------------------------- */

    const textOpacity = useTransform(
        progress,

        [
            Math.max(
                stepPosition - 0.10,
                0
            ),

            stepPosition,

            Math.min(
                stepPosition + 0.10,
                1
            ),
        ],

        [
            0,
            1,
            1,
        ]
    );


    const textY = useTransform(
        progress,

        [
            Math.max(
                stepPosition - 0.10,
                0
            ),

            stepPosition,
        ],

        [
            35,
            0,
        ]
    );


    return (

        <div className="mobile-process-card">

            {/* FIXED DOT */}

            <div className="mobile-process-point">

                <span />

            </div>


            {/* ONLY TEXT ANIMATES */}

            <motion.div
                className="mobile-process-content"

                style={{
                    opacity: textOpacity,
                    y: textY,
                }}
            >

                <span className="process-number">

                    Step{" "}

                    {String(
                        index + 1
                    ).padStart(
                        2,
                        "0"
                    )}

                </span>


                <h3>
                    {step.title}
                </h3>


                <p>
                    {step.text}
                </p>

            </motion.div>

        </div>
    );
}


/* =========================================================
   MAIN PROCESS SECTION
========================================================= */

export default function ProcessSection() {

    /* =====================================================
       DESKTOP REF
    ===================================================== */

    const timelineRef = useRef(null);


    /* =====================================================
       MOBILE REF
    ===================================================== */

    const mobileTimelineRef =
        useRef(null);


    /* =====================================================
       DESKTOP WIDTH
    ===================================================== */

    const [
        timelineWidth,
        setTimelineWidth,
    ] = useState(0);


    /* =====================================================
       GET DESKTOP TIMELINE WIDTH
    ===================================================== */

    useEffect(() => {

        const updateWidth = () => {

            if (
                !timelineRef.current
            ) {
                return;
            }


            setTimelineWidth(
                timelineRef.current
                    .offsetWidth
            );

        };


        updateWidth();


        const observer =
            new ResizeObserver(
                updateWidth
            );


        if (
            timelineRef.current
        ) {

            observer.observe(
                timelineRef.current
            );

        }


        window.addEventListener(
            "resize",
            updateWidth
        );


        return () => {

            observer.disconnect();

            window.removeEventListener(
                "resize",
                updateWidth
            );

        };

    }, []);


    /* =====================================================
       DESKTOP SCROLL PROGRESS
    ===================================================== */

    const {
        scrollYProgress,
    } = useScroll({

        target: timelineRef,

        offset: [
            "start 65%",
            "end 45%",
        ],

    });


    const smoothProgress =
        useSpring(
            scrollYProgress,
            {
                stiffness: 70,

                damping: 30,

                mass: 0.5,
            }
        );


    /* =====================================================
       MOBILE SCROLL PROGRESS
    ===================================================== */

    const {
        scrollYProgress:
        mobileScrollProgress,
    } = useScroll({

        target:
            mobileTimelineRef,

        offset: [
            "start 70%",
            "end 30%",
        ],

    });


    const mobileSmoothProgress =
        useSpring(
            mobileScrollProgress,
            {
                stiffness: 70,

                damping: 30,

                mass: 0.5,
            }
        );


    /* =====================================================
       DESKTOP BRASS POSITION
    ===================================================== */

    const firstDesktopPoint =
        timelineWidth * 0;


    const lastDesktopPoint =
        timelineWidth * 0.90;


    const desktopNutX =
        useTransform(

            smoothProgress,

            [0, 1],

            [
                firstDesktopPoint - 45,

                lastDesktopPoint - 45,
            ]

        );


    /* =====================================================
       MOBILE BRASS POSITION
    ===================================================== */

    /*
     * CSS position:
     *
     * 0%   = Step 01
     * 100% = Step 05
     */

    const mobileNutTop =
        useTransform(

            mobileSmoothProgress,

            [0, 1],

            [
                "0%",
                "100%",
            ]

        );


    return (

        <section className="process-section">

            <div className="process-container">


                {/* =================================================
                    HEADING
                ================================================= */}

                <motion.div
                    className="process-heading"

                    initial={{
                        opacity: 0,

                        y: 35,
                    }}

                    whileInView={{
                        opacity: 1,

                        y: 0,
                    }}

                    viewport={{
                        once: true,
                    }}

                    transition={{
                        duration: 0.7,

                        ease: "easeOut",
                    }}
                >

                    <span className="process-eyebrow">

                        / Our Process

                    </span>


                    <h2>

                        Unveiling The Process Of

                        <br />

                        Precision Brass Parts Production

                    </h2>

                </motion.div>


                {/* =================================================
                    DESKTOP HORIZONTAL PROCESS
                ================================================= */}

                <div
                    ref={timelineRef}

                    className="
                        process-timeline
                        desktop-process
                    "
                >

                    {/* BACKGROUND LINE */}

                    <div className="process-line" />


                    {/* ACTIVE LINE */}

                    <motion.div
                        className="
                            process-line-active
                        "

                        style={{
                            scaleX:
                                smoothProgress,
                        }}
                    />


                    {/* MOVING BRASS */}

                    <motion.div
                        className="
                            brass-nut-wrapper
                        "

                        style={{
                            x: desktopNutX,
                        }}
                    >

                        <BrassNut />

                    </motion.div>


                    {/* STEPS */}

                    <div className="process-grid">

                        {processSteps.map(
                            (
                                step,
                                index
                            ) => (

                                <DesktopProcessCard
                                    key={
                                        step.title
                                    }

                                    step={
                                        step
                                    }

                                    index={
                                        index
                                    }

                                    progress={
                                        smoothProgress
                                    }
                                />

                            )
                        )}

                    </div>

                </div>


                {/* =================================================
                    MOBILE / TABLET VERTICAL PROCESS
                ================================================= */}

                <div
                    ref={
                        mobileTimelineRef
                    }

                    className="
                        mobile-process
                    "
                >

                    {/* BACKGROUND VERTICAL LINE */}

                    <div
                        className="
                            mobile-process-line
                        "
                    />


                    {/* ACTIVE VERTICAL LINE */}

                    <motion.div
                        className="
                            mobile-process-line-active
                        "

                        style={{
                            scaleY:
                                mobileSmoothProgress,
                        }}
                    />


                    {/* MOVING BRASS */}

                    <motion.div
                        className="
                            mobile-brass-wrapper
                        "

                        style={{
                            top:
                                mobileNutTop,
                        }}
                    >

                        <BrassNut />

                    </motion.div>


                    {/* MOBILE STEPS */}

                    <div
                        className="
                            mobile-process-grid
                        "
                    >

                        {processSteps.map(
                            (
                                step,
                                index
                            ) => (

                                <MobileProcessCard
                                    key={
                                        step.title
                                    }

                                    step={
                                        step
                                    }

                                    index={
                                        index
                                    }

                                    progress={
                                        mobileSmoothProgress
                                    }
                                />

                            )
                        )}

                    </div>

                </div>

            </div>

        </section>
    );
}